import TradingVue from "trading-vue-js";
import Overlays from "tvjs-overlays";
import { DataCube } from "trading-vue-js";
import { TradingViewService } from "@/services";
import { mapActions, mapGetters } from "vuex";
import * as types from "@/store/types";
import debounce from "lodash-es/debounce";

export default {
  name: "trading-view",
  components: {
    TradingVue
  },
  props: ["tradingViewHeight"],
  data() {
    return {
      chartRange: [0, 0],
      chartQuery: {
        iso: "USDT",
        iso_base: "IRR",
        interval: "hourly",
        page: 1,
        time_start: 0,
        time_end: 0
      },
      selectedTab: 0,
      dialog: false,
      overlays: Object.values(Overlays),
      chart: new DataCube({
        chart: {
          // type: "Spline",
          type: "Candles",
          data: [],
          // tf: 3600000,
          tf: "1h",
          settings: {
            // upper: 70,
            // lower: 30,
            backColor: "red",
            bandColor: "var(--v-gray10-base)"
          },
          grid: {}
        }
      }),
      windowSize: {
        x: 0,
        y: 0
      },
      fullWindowSize: {
        x: 0,
        y: 0
      },
      windowSizeMobile: {
        x: 100,
        y: 100
      },
      chartFullHeight: ""
    };
  },
  computed: {
    ...mapGetters({
      getTradingViewData: types.tradingView.getters.GET_TRADING_VIEW_DATA,
      fromCurrencyId: types.market.getters.GET_SELECTED_BASE_CURRENCY,
      toCurrency: types.market.getters.GET_TO_CURRENCY,
      defaultToCurrency: types.market.getters.GET_DEFAULT_TO_CURRENCY,
      getBaseCurrencies: types.market.getters.GET_BASE_CURRENCIES_DATA
    }),
    toCurrencyIso() {
      return this.toCurrency.iso;
    },
    fromCurrencyIso() {
      let iso = "";
      this.getBaseCurrencies.find(item => {
        if (this.fromCurrencyId === item.id) {
          // console.log(item);
          iso = item.iso;
        }
      });
      return iso;
    },
    setCurrenciesIso() {
      let from = "";
      this.getBaseCurrencies.find(item => {
        if (this.fromCurrencyId === item.id) {
          from = item.iso;
        }
      });
      let to = this.toCurrency.iso;
      return {
        from,
        to
      };
    },
    chartTitle() {
      return this.toCurrencyIso + "/" + this.fromCurrencyIso;
    }
  },
  watch: {
    setCurrenciesIso: {
      immediate: true,
      handler(newValue, oldValue) {
        if (
          !(newValue?.to === oldValue?.to && newValue?.from === oldValue?.from)
        ) {
          this.chartQuery.iso = newValue?.to;
          this.chartQuery.iso_base = newValue?.from;
          this.sendChartDataRequest();
        }
      }
    }
  },
  mounted() {
    window.addEventListener("resize", this.onResize);
    this.onResize();
    this.$nextTick(() => {
      this.initChartRange();
    });
  },
  methods: {
    ...mapActions({
      setTradingViewData: types.tradingView.actions.SET_TRADING_VIEW_DATA
    }),
    onResize() {
      this.windowSize = {
        x: this.$refs.tradingViewInner.clientWidth - 10,
        y: this.tradingViewHeight - 408
      };
      this.fullWindowSize = {
        x: window.innerWidth - 50,
        y: window.innerHeight - 70
      };
      this.windowSizeMobile = {
        x: window.innerWidth - 50,
        y: window.innerHeight - 408
      };
    },
    maleFullScreen() {
      this.dialog = !this.dialog;
      if (this.dialog) {
        this.fullWindowSize = {
          x: window.innerWidth - 50,
          y: window.innerHeight - 70
        };
      } else {
        this.onResize();
      }
    },
    sendChartDataRequest: debounce(function() {
      this.chartRange = [...this.$refs.tradingView.getRange()];
      this.chartQuery.time_start = this.chartRange[0];
      this.chartQuery.time_end = this.chartRange[1];
      this.getChartData();
    }, 1000),
    getChartData() {
      TradingViewService.getCryptoTechnicalData(this.chartQuery).then(
        response => {
          this.setTradingViewData(response.data.data);
          this.filterTradingViewData(response.data.data);
        }
      );
    },
    filterTradingViewData(data) {
      let tradingViewArray = [...data];
      let result = [];
      tradingViewArray.forEach(elem => {
        let chartArray = [];
        chartArray = ["time", "open", "high", "low", "close", "volume"];
        Object.keys(elem).forEach(key => {
          chartArray.forEach((item, index) => {
            if (key === item) {
              if (key === "time") {
                chartArray[index] = elem[key] * 1000;
              } else {
                chartArray[index] = elem[key];
              }
            }
          });
        });
        result.push(chartArray);
      });
      this.chart.data.chart.data = result;
    },
    onTimeFilterChange(filter) {
      this.chartQuery.interval = filter.value;
      this.getChartData();
    },
    initChartRange() {
      const endTime = +new Date();
      const startTime = endTime - 3 * 24 * 3600 * 1000;
      this.$refs.tradingView.setRange(startTime, endTime);
    },
    onmousedown() {
      this.sendChartDataRequest();
    }
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  }
};
